export * from './ElectronicConsent';
